import Untrusive from "untrusive";

export const untrusive = new Untrusive({
  barColor: "black",
  bgColor: "black",
});
